import Profile from '../../components/Profile';

export default function AdminProfile() {
  return <Profile role="admin" />;
}